import { GetXcoreStaticContext, useContent, usePageContent, XcoreOptions } from "@appiodev/xcore-client/xcore-ui";
import { LayoutNoHead } from "components/Layout";
import RobeHead from "components/RobeHead";
import { useRouter } from "next/router";
import ProductOverview from "templates/products/ProductOverview";
import { featuredItemsField } from "utils/products";
import { useTagManager } from "utils/useTagManager";
import { getRobePaths, getRobeProps, RobePage } from "xcore";
import { ProductOverviewPage, Products } from "xcore/types";

export const getXcoreOptions = (
  { cms, id }: GetXcoreStaticContext
): Partial<XcoreOptions<Products | ProductOverviewPage>> => ({
  pageContent: cms.content.single(id ?? "products", {
    preview: true,
    relations: v => [
      featuredItemsField(cms.locales.content).map(f => v[f]?.$options([
        "heading",
        "images",
        "discontinuedGlob",
        "discontinuedReg",
        "name",
        "thumbnailTitle",
        "title",
        "thumbImage",
        "thumbImageProduct",
        "newIcon",
        "ipCertifiedIcon",
        "textTag"
      ] as any))
    ]
  }),
  contents: [
    cms.content.list<Products>("products", {
      includeRelations: true,
      fields: [
        "middlePageApplication",
        "middlePageBeamType",
        "middlePageProductFamily",
        "middlePageProductType",
        "browseAllBtn",
        "leftLabelName",
        "leftPlaceholderText",
        "midLabelName",
        "midPlaceholderName",
        "rightLabelName",
        "rightPlaceholderText"
      ]
    })
  ],
  content: [cms.content.single<Products>("products")],
  categories: [
    cms.taxonomy.list<ProductOverviewPage>("product-type", { includeContents: true }),
    cms.taxonomy.list<ProductOverviewPage>("product-size", { includeContents: true }),
    cms.taxonomy.list<ProductOverviewPage>("beam-type", { includeContents: true })
  ]
});

export const getStaticProps = getRobeProps(getXcoreOptions);

export const getStaticPaths = getRobePaths("productOverviewPage");

const ProductOverviewPagePage: RobePage = () => {
  const [{ values }, { stringify, richtextToString }] = usePageContent<ProductOverviewPage | Products>();
  const [products] = useContent<[Products]>();
  const { query } = useRouter();
  const isProductDetail = !!query.id; // differentiate overview index and overview detail pages for different title purposes

  useTagManager("product-listing");

  return (
    <>
      <RobeHead
        title={isProductDetail ? [stringify(products.title), stringify(values.title)] : [stringify(values.title)]}
        description={richtextToString(values.intro)}
      />
      <ProductOverview />
    </>
  );
};

ProductOverviewPagePage.Layout = LayoutNoHead;

export default ProductOverviewPagePage;
